"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CurrencyRange = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CurrencyInput = _interopRequireDefault(require("../CurrencyInput"));

var _Range = _interopRequireDefault(require("../Range"));

var _ErrorHandlingFormHelperText = _interopRequireDefault(require("../ErrorHandlingFormHelperText"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CurrencyRange = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CurrencyRange, _Component);

  var _super = _createSuper(CurrencyRange);

  function CurrencyRange() {
    var _this;

    (0, _classCallCheck2.default)(this, CurrencyRange);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          autoFocus = _this$props.autoFocus,
          disabled = _this$props.disabled,
          fromProps = _this$props.fromProps,
          helperText = _this$props.helperText,
          label = _this$props.label,
          id = _this$props.id,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          required = _this$props.required,
          toProps = _this$props.toProps,
          value = _this$props.value,
          error = _this$props.error,
          errorMessage = _this$props.errorMessage,
          className = _this$props.className;
      var errorMessageFrom = typeof errorMessage === "string" ? errorMessage : errorMessage.from;
      var errorMessageTo = typeof errorMessage === "string" ? errorMessage : errorMessage.to;
      var errorFrom = typeof error === "string" ? error : error.from;
      var errorTo = typeof error === "string" ? error : error.to;
      var errorGlobal = typeof error === "string" ? error : error.to || error.from;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Range.default, {
        autoFocus: autoFocus,
        component: _CurrencyInput.default,
        disabled: disabled,
        error: errorGlobal,
        fromProps: {
          errorMessage: errorMessageFrom,
          error: errorFrom,
          label: fromProps.label,
          placeholder: fromProps.placeholder,
          disabled: disabled,
          fullWidth: fromProps.fullWidth
        },
        id: id,
        className: "prmbl-currencyRange ".concat(className),
        label: label,
        onChange: onChange,
        onBlur: onBlur,
        required: required,
        toProps: {
          errorMessage: errorMessageTo,
          error: errorTo,
          label: toProps.label,
          placeholder: toProps.placeholder,
          disabled: disabled,
          fullWidth: toProps.fullWidth
        },
        value: value
      }), /*#__PURE__*/_react.default.createElement(_ErrorHandlingFormHelperText.default, {
        id: id,
        helperText: helperText
      }));
    });
    return _this;
  }

  return CurrencyRange;
}(_react.Component);

exports.CurrencyRange = CurrencyRange;
(0, _defineProperty2.default)(CurrencyRange, "propTypes", {
  /**
   * If `true`  the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * If `true` the label, input, and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * 	If `true`, the input will indicate an error. And display the provided errorMessage
   */
  error: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
    from: _propTypes.default.bool,
    to: _propTypes.default.bool
  })]),

  /**
   * The message to display when `error` is `true`.
   */
  errorMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    from: _propTypes.default.string,
    to: _propTypes.default.string
  })]),

  /**
   * Container to store all the properties for the `from` component
   */
  fromProps: _propTypes.default.shape({
    /**
     * Makes the input span the entire component's width
     */
    fullWidth: _propTypes.default.bool,

    /**
     * The contents of the `label`
     */
    label: _propTypes.default.node,

    /**
     * Placeholder to display before a user enters a value
     */
    placeholder: _propTypes.default.string
  }),

  /**
   * The contents of the `helper text`
   */
  helperText: _propTypes.default.node,

  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * The contents of the `label`
   */
  label: _propTypes.default.node,

  /**
   * Callback fired when the value is changed.  `function(event: object, value: object) => void`
   *
   * `event` : The event source of the callback.
   *
   *
   * `value` : The value of the range. { from: ..., to: ... }
   */
  onChange: _propTypes.default.func.isRequired,

  /**
   * Callback to be called when the user switches focus from the input
   *
   * function(event: object) => void
   * `event` : The event source of the callback.
   */
  onBlur: _propTypes.default.func,

  /**
   * Sets the component as required.
   */
  required: _propTypes.default.bool,

  /**
   * Container to store all the properties for the `to` component
   */
  toProps: _propTypes.default.shape({
    /**
     * Makes the input span the entire component's width
     */
    fullWidth: _propTypes.default.bool,

    /**
     * The contents of the `label`
     */
    label: _propTypes.default.node,

    /**
     * Placeholder to display before a user enters a value
     */
    placeholder: _propTypes.default.string
  }),

  /**
   * The value of the range object
   */
  value: _propTypes.default.shape({
    /**
     * Value of the `From` input
     */
    from: _propTypes.default.string,

    /**
     * Value of the `To` input
     */
    to: _propTypes.default.string
  }).isRequired,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string
});
(0, _defineProperty2.default)(CurrencyRange, "defaultProps", {
  toProps: {},
  fromProps: {},
  className: ""
});
var _default = CurrencyRange;
exports.default = _default;